export default "__VITE_ASSET__0jMwHXHI__"